module.exports = __webpack_public_path__ + "img/chat-details7.1037dad1.png";